import { FC } from 'react';
import { Box, Container, Grid, Typography } from '@mui/material';

import { styled } from '@mui/material/styles';


const TypographyH1 = styled(Typography)(
  ({ theme }) => `
    font-size: ${theme.typography.pxToRem(35)};
`
);

const TypographyH2 = styled(Typography)(
  ({ theme }) => `
    font-size: ${theme.typography.pxToRem(15)};
`
);

interface IthPresentationProps {
}

const IthPresentation: FC<IthPresentationProps> = ({
}) => {
  
  return (
    <Container maxWidth="lg" sx={{ textAlign: 'center' }}>      
      <Grid
        spacing={{ xs: 6, md: 1 }}
        justifyContent="center"
        alignItems="center"
        container
      >
        <Grid item md={8} lg={8} mx="auto">
          <TypographyH1 sx={{ mb: 2 }} variant="h1">
            Aplicación de cuestionarios de ITH
          </TypographyH1>
          <TypographyH2 sx={{ lineHeight: 1.5, pb: 4 }} variant="h4"color="text.secondary" fontWeight="normal">
            Bienvenido a la Herramienta de Diagnóstico “Modelo ITH de Sostenibilidad Turística” desarrollada por el ITH y 
            subvencionada por la Secretaría de Estado de Turismo, que le ayudará a gestionar su establecimiento de forma más 
            sostenible y le ayudará a planificar sus actuaciones alineadas con los Objetivos de Desarrollo Sostenible definidos 
            por las Naciones Unidas.
          </TypographyH2>
          <TypographyH2 sx={{ lineHeight: 1.5, pb: 4 }} variant="h4"color="text.secondary" fontWeight="normal">
            Esta herramienta facilita una hoja de ruta para ayudar al empresario turístico a fijar las actuaciones más adecuadas 
            para su establecimiento, en materia de sostenibilidad económica, social y medioambiental y a la mejora continua de las mismas. 
            El diagnóstico se lleva a cabo a través de un check list, que le permitirá evaluar su establecimiento con una puntuación 
            asignada en función de sus respuestas y con recomendaciones al respecto, para mejorar dicha evaluación. Igualmente le 
            permitirá una clasificación con respecto al nivel de cumplimiento de los ODS y por tanto identificar qué Objetivos está 
            priorizando el establecimiento.
          </TypographyH2>
          
        </Grid>
        
      </Grid>
    </Container>
  );
}

IthPresentation.propTypes = {
};

export default IthPresentation;
